// Custom components
import React from "react";

function InputField(props: {
  id: string;
  label: string;
  extra: string;
  placeholder: string;
  variant: string;
  state?: string;
  name?: string;
  disabled?: boolean;
  readonly?: boolean;
  type?: string;
  autoComplete?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  error?: string;
  helptext?: string;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  labelAsLink?: string;
  hideLabel?: boolean;
  required?: boolean;
}) {
  const {
    label,
    id,
    extra,
    type,
    placeholder,
    variant,
    name,
    disabled,
    readonly,
    autoComplete,
    value,
    onChange,
    onBlur,
    error,
    helptext,
    onKeyDown,
    labelAsLink,
    hideLabel,
    required
  } = props;

  return (
    <div>
      {!hideLabel && (
        <label
          htmlFor={id}
          className={`text-sm text-navy-700 ${
            variant === "auth" ? "font-medium" : "font-bold"
          }`}
        >
          {labelAsLink && labelAsLink !== "" ? (
            <a
              rel="noreferrer"
              href={labelAsLink}
              target="_blank"
              className="underline hover:text-primary-500"
            >
              {label}
            </a>
          ) : (
            label
          )}
          {required && <span className="text-red-500"> *</span>}
        </label>
      )}
      <input
        value={value}
        autoComplete={autoComplete}
        disabled={disabled}
        readOnly={readonly}
        type={type}
        name={name}
        id={id}
        placeholder={placeholder}
        className={`w-full rounded-md border border-gray-300 px-4 py-2.5 text-sm font-medium tracking-tight outline-none placeholder:font-medium ${extra}`}
        onChange={onChange}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
      />
      {helptext && (
        <p className={"text-sm text-gray-500 " + (error ? "" : "mb-3")}>
          {helptext}
        </p>
      )}
      {error && <p className={"mb-3 text-sm text-red-500"}>{error}</p>}
    </div>
  );
}

export default InputField;
